import React from 'react';
import styles from './WorldCupGoldenBoot.module.css';
import OptimizedImage from '../player/OptimizedImage';
import { getApiHost } from '../../../server/services/custom-pages/apiHost';

export default function WorldCupGoldenBoot({ players, photoMap = {} }) {
  if (!players || players.length === 0) {
    return (
      <div className={styles.bootSectionContainer}>
        <h2 className={styles.bootSectionHeading}>Golden Boot</h2>
        <div className={styles.bootFullDivider} />
        <p className={styles.statusMsg}>Tournament hasn't started yet</p>
      </div>
    );
  }

  return (
    <div className={styles.bootSectionContainer}>
      <h2 className={styles.bootSectionHeading}>Golden Boot</h2>
      <div className={styles.bootFullDivider} />
      <div className={styles.goldenBootGrid}>
        {players.map((player) => {
          const getColumnValue = (id) => {
            const column = player.columns?.find(col => col.id === id);
            return column?.value;
          };

          const playerId = player.id;
          const playerName = player.name;
          const teamName = player.subparticipant_name;
          const countryName = player.area_name;
          const goals = getColumnValue(6) || 0; // Actual goals scored (Column ID 6)
          const xgValue = player.xg || 0;       // Expected Goals (from detailed player stats)
          const goalsPerMatch = getColumnValue(393);
          const photoUrl = photoMap[String(player.id)] || `${getApiHost()}/player/fallback.png`;
          
          return (
            <div key={playerId} className={styles.goldenBootCard}>
              <p className={styles.goldenBootPlayerName}>{playerName}</p>
              <p className={styles.goldenBootPlayerPosition}>{countryName}</p>
              <div className={styles.goldenBootImageWrapper}>
                <OptimizedImage
                  src={photoUrl}
                  alt={playerName}
                  width={328}
                  height={328}
                  unoptimized
                  className={styles.goldenBootPlayerPhoto}
                />
                <div className={styles.goldenBootImageFade} />
              </div>
              <div className={styles.goldenBootStats}>
                <div className={styles.statBlock}>
                  <div className={styles.xgRow}>
                    <span className={styles.xgLabel}>xG</span>
                    <span className={styles.xgNumber}>{xgValue}</span>
                  </div>
                  <div className={styles.progressBarTrack}>
                    <div className={styles.xgProgressFill} style={{ width: `${Math.min((xgValue / 10) * 100, 100)}%` }} />
                  </div>
                </div>
                <div className={styles.statBlock}>
                  <div className={styles.actualGoalsRow}>
                    <span className={styles.actualGoalsLabel}>Actual Goals</span>
                    <span className={styles.actualGoalsNumber}>{goals}</span>
                  </div>
                  <div className={styles.progressBarTrack}>
                    <div className={styles.actualProgressFill} style={{ width: `${Math.min((goals / 10) * 100, 100)}%` }} />
                  </div>
                </div>
                <div className={styles.progressBarScale}>
                  <span className={styles.scaleMin}>0</span>
                  <span className={styles.scaleQ1}>2.5</span>
                  <span className={styles.scaleQ2}>5</span>
                  <span className={styles.scaleQ3}>7.5</span>
                  <span className={styles.scaleMax}>10</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
